import tinymce from 'tinymce'
import plugin from './plugin'
import {DAUMBLOG} from "../../../../../../../admin/src/constants/Service";

if (window.Config.service === DAUMBLOG) {
  tinymce.PluginManager.add('daumblog-converter', plugin);
}
